import { render, staticRenderFns } from "./layout-menu.vue?vue&type=template&id=30975091&"
import script from "./layout-menu.vue?vue&type=script&lang=js&"
export * from "./layout-menu.vue?vue&type=script&lang=js&"
import style0 from "./layout-menu.vue?vue&type=style&index=0&id=30975091&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports